import _ from "lodash";

export function normalizeIdentityId(value) {
	return _.toString(value || "").trim();
}

export function getInventoryEntryOwnerIdentityId(activity = {}) {
	return normalizeIdentityId(
		_.get(activity, "identityId", "") ||
		_.get(activity, "ownerIdentityId", "") ||
		_.get(activity, "ownerId", "") ||
		_.get(activity, "sharedArtifactOwnerId", "")
	);
}

export function getOrgMemberIdentityIds(selectedOrg = {}, currentIdentityId = "") {
	const memberIdsFromMap = _.keys(_.get(selectedOrg, "membersMap", {}));
	const memberIdsFromArray = _.flatMap(_.get(selectedOrg, "members", []), (member) => [
		_.get(member, "id", ""),
		_.get(member, "userSubId", "")
	]);
	const selectedMemberIds = [
		_.get(selectedOrg, "member.id", ""),
		_.get(selectedOrg, "member.userSubId", "")
	];

	return _.uniq([]
		.concat(memberIdsFromMap, memberIdsFromArray, selectedMemberIds, [
			_.get(selectedOrg, "id", ""),
			currentIdentityId
		])
		.map(normalizeIdentityId)
		.filter(Boolean));
}

export function isAllowedPublicInventoryOwner(ownerIdentityId, orgId = "") {
	const owner = normalizeIdentityId(ownerIdentityId);
	const currentOrgId = normalizeIdentityId(orgId);

	return owner === "public" || (currentOrgId !== "" && owner === `${currentOrgId}/public`);
}

export function isForeignInventoryOwner(activity = {}, context = {}) {
	const ownerIdentityId = getInventoryEntryOwnerIdentityId(activity);
	if (!ownerIdentityId) {
		return false;
	}

	const currentIdentityId = normalizeIdentityId(context.currentIdentityId);
	const selectedOrg = context.selectedOrg || {};
	const orgId = normalizeIdentityId(context.orgId || _.get(selectedOrg, "id", ""));
	if (isAllowedPublicInventoryOwner(ownerIdentityId, orgId)) {
		return false;
	}

	const validOwnerIds = getOrgMemberIdentityIds(selectedOrg, currentIdentityId);
	if (validOwnerIds.indexOf(ownerIdentityId) !== -1) {
		return false;
	}

	if (ownerIdentityId.indexOf("/") !== -1) {
		return true;
	}

	const hasLoadedMemberDirectory = _.keys(_.get(selectedOrg, "membersMap", {})).length > 0 ||
		_.get(selectedOrg, "members", []).length > 0;

	// Without member context, fail open so we do not hide legitimate same-org shares.
	return hasLoadedMemberDirectory;
}

export function getInventoryEntryIntegrityIssue(activity = {}, context = {}) {
	if (!activity || activity.newDoc) {
		return null;
	}

	const hasValidId = _.isString(activity.id) && activity.id.trim() !== "";
	const hasValidName = _.isString(activity.name) && activity.name.trim() !== "";

	if (!hasValidId) {
		return {
			key: "missingId",
			label: "Missing activity id."
		};
	}

	if (!hasValidName) {
		return {
			key: "missingName",
			label: "Missing activity name."
		};
	}

	if (isForeignInventoryOwner(activity, context)) {
		const ownerIdentityId = getInventoryEntryOwnerIdentityId(activity);
		return {
			key: "foreignOwner",
			label: `Owner identity ${ownerIdentityId} is not part of the selected organization.`
		};
	}

	return null;
}

export function filterForeignInventoryEntries(activities = [], context = {}) {
	const kept = [];
	const removed = [];

	(_.isArray(activities) ? activities : []).forEach((activity) => {
		const issue = getInventoryEntryIntegrityIssue(activity, context);
		if (issue && issue.key === "foreignOwner") {
			removed.push({ activity, issue });
		} else {
			kept.push(activity);
		}
	});

	return { kept, removed };
}
